import { doc, getDoc, onSnapshot, collection } from "firebase/firestore";
import { db } from "@/fb";
import { config } from "@/utils/configuration/config";

export default class FuelTypeRepoFirebase {
    constructor() {
        //console.log("Construyendo FuelTypeRepoFirebase");
    }

    async getFuelType(ref, consumption, ship, callback){
        const docRef = doc(db, config.firebaseConfig.fuelTypesCollectionName, ref);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            const data = docSnap.data();
            const typeReceived = {
              id: ref,
              ...data,
            };
            callback(ref, consumption, ship, typeReceived);
        } else {
            // doc.data() will be undefined in this case
            //console.log("FuelTypeRepoFirebase - No such document!");
        }
    }

    async getAllTypes(types, service){

        //console.log("FuelTypeRepoFirebase-getTypes");
        onSnapshot(collection(db, config.firebaseConfig.fuelTypesCollectionName), (querySnapshot) => {
        const changes = querySnapshot.docChanges();

            changes.forEach(async (change) => {
            if (change.type === "added") {
                service(types, {
                id: change.doc.id,
                ...change.doc.data(),
                });
            }
            });
        });

    }

}